const TIME_ZONE_OFFSET = new Date().getTimezoneOffset() * 60 * 1000 * -1;

/**
 * @param {Date} date
 * @return {Date} - returns datetime with applied client timezone offset
 */
export const applyTimeZoneOffset = (date) => new Date(date.getTime() + TIME_ZONE_OFFSET);
